import styled from 'styled-components';

import { protectStatuses } from '../../MainSettings/ValidationRule/utils';

export const Wrapper = styled.div`
  border: 1px solid rgba(0, 36, 77, 0.05);
  box-shadow: 0 1px 4px 0 rgba(0, 36, 77, 0.08);
  box-sizing: border-box;
  border-radius: 8px;
  height: 100%;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  padding: 24px 32px;
  justify-content: flex-start;
  cursor: pointer;
  position: relative;
`;

export const CardHeader = styled.div<{ disabled: boolean }>`
  ${(p) => p.theme.typography.subHeader};
  color: ${(p) => (p.disabled ? p.theme.colors.disabled : p.theme.colors.brand)};
`;

export const HeaderIconWrapper = styled.div`
  transition: transform 0.15s ease-out;
  border: 2px solid ${(p) => p.theme.colors.brand};
  border-radius: 50%;
  color: ${(p) => p.theme.colors.brand};
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin-right: 12px;
`;

export const CardHeaderDescription = styled.div`
  ${(p) => p.theme.typography.description};
  color: ${(p) => p.theme.colors.muted};
  font-weight: normal;
  margin-top: 8px;
`;

export const StatusWrapper = styled.div<{ status: protectStatuses }>`
  ${(p) => p.theme.typography.label};
  position: absolute;
  right: 0;
  line-height: 24px;
`;

export const ContentWrapper = styled.div<{ isOpenContent: boolean }>`
  overflow: hidden;
  padding: ${(props) => (props.isOpenContent ? '0 36px 24px' : '0')};
  height: ${(props) => (props.isOpenContent ? 'auto' : '0px')};
  transition: height 0.15s ease-out;
`;
